import React from 'react';

import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';

import { IconEditPencil, IconTrash } from '../Icons';
import Badge, { KINDS } from '../Badge';
import Button from '../Button';

const SettingsBox = ({
  canDelete = false,
  canEdit = false,
  children,
  className,
  onDelete,
  onEdit,
  title,
  tags,
}) => {
  const cn = useClassNames(
    () => [
      'flex',
      'flex-row',
      'bg-slate-100',
      'border',
      'border-slate-300',
      'rounded',
      'relative',
      className,
    ],
    [className],
  );

  // prevents tags from being displayed behind action items
  const actionsPlaceholder = (Number(canEdit) + Number(canDelete)) * 8;

  return (
    <div data-component="SettingsBox" className={cn}>
      <div className="overflow-x-hidden flex-grow p-4">
        {!!tags.length && (
          <div
            className={`flex flex-wrap gap-x-2 gap-y-2 items-start justify-start justify-items-start align-top mb-2 pr-${actionsPlaceholder}`}
          >
            {tags.map(({ value, id }) => (
              <Badge className="min-w-[50px]" key={id} kind={KINDS.SECONDARY}>
                {value}
              </Badge>
            ))}
          </div>
        )}
        {title && <div className="font-semibold text-blue-500 mb-3">{title}</div>}
        {children}
      </div>
      <div className="absolute top-0 right-0">
        {canEdit && (
          <Button onClick={onEdit} className="flex-shrink-0" kind="secondary:ghost" shape="circle">
            <IconEditPencil size="5" />
          </Button>
        )}
        {canDelete && (
          <Button
            onClick={onDelete}
            className="flex-shrink-0"
            kind="secondary:ghost"
            shape="circle"
          >
            <IconTrash size="5" />
          </Button>
        )}
      </div>
    </div>
  );
};

SettingsBox.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  canDelete: PropTypes.bool,
  canEdit: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ),
};

SettingsBox.defaultProps = {
  title: '',
  canDelete: false,
  canEdit: false,
  children: null,
  className: null,
  onDelete: () => {},
  onEdit: () => {},
  tags: [],
};

export default SettingsBox;
